import { colors, fonts } from '@grupoboticario/flora-tokens/monocromatico/web/ds'

export const monocromatico = {
  colors,
  fonts,
}
